export var classNames = {
  FIXED: "-sticky",
  SHOW: "-sticky-show",
  HIDE: "-sticky-hide",
  OFFSET: "-is-offset"
};
export var selectors = {
  TOGGLE: ".ef-header__menu-toggle",
  STICKYEL: ".ef-header__main",
  NAV: ".ef-nav",
  TRANSPARENT: "-transparent",
  FULLBLEED: "ef-fullbleed"
};
export var typeConfig = {
  extended: {
    elHeight: 112,
    stickyOffset: 48
  },
  condensed: {
    elHeight: 64,
    stickyOffset: 0
  },
  global: {
    elHeight: 48,
    stickyOffset: 0
  }
};
export var defaultConfig = {
  sticky: true,
  type: "extended",
  trigger: undefined
};
export var DATA_KEY = "ef.header";
export var EVENT_KEY = ".".concat(DATA_KEY);